const allFields = require('./allFields.json');

// 只允许输入数字和字母的字段 businessDescription
let numLetterParams = ['firstName', 'middleName', 'lastName', 'suffix', 'streetAddress', 'businessName', 'businessName_1', 'accountName', 'merchantId', 'purposeOfApplication', 'subdivision']
// 只允许输入数字字段
let numberParams = ['tin', 'accountNumber', 'zipCode']
// 数字字母正则
let numberAndLetterRule = /^[a-zA-Z0-9 ]*$/
// 数字正则
let numberRule = /^[0-9]*$/
// 邮箱正则
// let emailRule = /^([a-zA-Z0-9])+@([a-zA-Z0-9])+(.[a-zA-Z])+/
// let emailRule = /^[a-z0-9A-Z]+[-|a-z0-9A-Z._]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-z]{2,}$/
// let emailRule = /^([a-zA-Z0-9]{1,})+([a-zA-Z0-9.]{0,})+@([a-zA-Z0-9]{1,})+(\.[a-zA-Z.]{1,})$/
let emailRule = /^[a-z0-9A-Z]+([-! #$%&'*+-/=?^_`{|}~.a-z0-9A-Z]){0,}@[a-z0-9A-Z]+([-! #$%&'*+-/=?^_`{|}~a-z0-9A-Z]){0,}(\.[a-zA-Z]{1,})$/

const formRules = Object.keys(allFields).reduce((acc, item)=> {

  // 添加必填校验
  acc[item] = [
    {
      required: allFields[item].required,
      trigger: ['blur','change'], // 更改校验配置项
      message: allFields[item].emptyMsg ? allFields[item].emptyMsg : `${allFields[item]["labelTxt"]} is error`,
    }
  ]

  // 判断只能输入字母和数字
  if(numLetterParams.includes(item)) {
    acc[item].push({
      pattern: numberAndLetterRule,
      message: allFields[item].errorMsg ? allFields[item].errorMsg : `${allFields[item]["labelTxt"]} is error`,
      trigger: ['blur','change'] // 更改校验配置项
    })
  }

  //判断只能输入数字
  if(numberParams.includes(item)) {
    acc[item].push( {
      pattern: numberRule,
      message: allFields[item].errorMsg ? allFields[item].errorMsg : `${allFields[item]["labelTxt"]} is error`,
      trigger: ['blur','change'] // 更改校验配置项
    })
  }

  if(item == 'accountNumber') {
    acc[item].push( {
      pattern: /^[0-9]{12}$/,
      message: allFields[item].emptyMsg ? allFields[item].emptyMsg : `${allFields[item]["labelTxt"]} is error`,
      trigger: ['blur','change'] // 更改校验配置项
    })
  }

  //判断字段含有Email, 则添加 email 正则
  if(item.toLowerCase().endsWith('email')) {
    acc[item].push( {
      pattern: emailRule,
      message: 'Enter a valid email address',
      trigger: ['blur','change'] // 更改校验配置项
    })
  }

  //  bdo 电话号码判断
  if(['mobile'].includes(item)) {
    acc[item].push({
      pattern: /^\+\d{2,3}-\d{10}$/,
      message: allFields[item].errorMsg ? allFields[item].errorMsg : `${allFields[item]["labelTxt"]} is error`,
      trigger: ['blur','change'] // 更改校验配置项
    })
  }

  // 生日正则
  if(item == 'birthday') {
    acc[item].push({
      validator: (rule, value, callback) => {
        const [ year, mouth, day ] = value.split('-')
        if(!mouth) {
          callback(new Error('Select month'))
        } else if(!day) {
          callback(new Error('Enter Day of birth'))
        } else if (!numberRule.test(day)) {
          callback(new Error('Please use numbers only'))
        } else if(!year) {
          callback(new Error('Enter Birth year'))
        } else if(!numberRule.test(year)) {
          callback(new Error('Please use numbers only'))
        } else {
          callback()
        }
      },
      trigger: ['change', 'blur'] // 更改校验配置项
    })
  }

  return acc
},{})

module.exports =  {
  formRules
}